const getCssPath = subdomain => {
  if (process.env.NODE_ENV === 'production') {
    return `https://scoreplay-fan-playground.s3.amazonaws.com/themes/${subdomain}.css`
  } else {
    return `https://scoreplay-fan-playground.s3.amazonaws.com/themes/${subdomain}.css`
    //return `/themes_local/${subdomain}.css`
  }
}

export const loadCss = subdomain => {
  const cssURL = getCssPath(subdomain)
  return new Promise(resolve => {
    var link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = cssURL
    document.head.appendChild(link)
    link.onload = () => {
      resolve()
    }
    link.onerror = () => {
      resolve()
    }
  })
}

const getFileExtension = filename => {
  if (!filename) return null
  return filename.split('.').pop().toLowerCase()
}

export const isVideo = filename => {
  const ext = getFileExtension(filename)
  if (!ext) return false
  if ('.mp4.mov.wmv.flv.avi.mkv.m4v'.indexOf(ext) > -1) return true
}

export const getInstaHandle = socials => {
  const instagramData = socials.find(
    platform => platform.text.toLowerCase() === 'instagram'
  )
  if (!instagramData) return null
  const rx =
    /^(?:@|(?:https?:\/\/)?(?:www\.)?instagr(?:\.am|am\.com)\/)?([\w.]+)\/?$/g
  let match = rx.exec(instagramData.url)
  return match?.length > 0 ? `@${match[1]}` : null
}

export const isUrlGif = url => {
  if (url.includes('.gif')) return true
  return false
}
